export const PHONE_MARKER = "__JET_HAT_PLACEHOLDER__";

const phoneMasking = (input) => {
  if (!input) return input;

  const phoneRegexPattern =
    /(((\+)?[ \-\.]*\d[ \-\.]*)?0[ \-\.]*((\(( *))(\d( *)){3}(\)( *)))[\d \-\.]*)|(((\(( *))(\d( *)){3}(\)( *)))[\d \-\.]*)|\+?\d{12}|\d{11}/gi;
  let replacedText = input.replace(phoneRegexPattern, PHONE_MARKER);

  const patterns = [
    { regex: /((\+[ \-\.]*)\d[\d \-\.]*\d)/ig, size: 12 },
    { regex: /((\d[ \-\.]*){2} [\d \-\.]*\d)/ig, size: 12 },
    { regex: /( (\d[ \-\.]*){2}\-[\d \-\.]*\d)/ig, size: 12 },
    { regex: /((\d\-){11}\d)/ig, size: 12 },
    { regex: /((\d[ \-\.]*){2} [\d \-\.]*\d)/ig, size: 12 },
    { regex: /((\d[ \-\.]*)(\d[ \-\.]*){3}(\d[ \.]* )*\d)/ig, size: 11 },
    { regex: /(((0\d{3} \d{3} \d{2} \d{2}) ){3})/ig, size: 33 },
    { regex: /((\d[ \-\.]*)(\d[ \-\.]*){3}(\d[ \-\.]*)*\d)/ig, size: 11 },
    { regex: /((0\d{3})[ \-\.]?(\d{3})[ \-\.]?(\d{2})[ \-\.]?(\d{2})[ \-\.]?(\d{10}))/ig, size: 21 },
    { regex: /((\d{3}[ \-\.]*)(\d[ \-\.]*)*\d)/ig, size: 10 },
    { regex: /(((\d[ \-]*){3}[ \-\.]*)(\d[ \-\.]*)*\d)/ig, size: 10 },
    { regex: /(\d[ \-\.]*(\d[ \-\.]*)*\d)/ig, size: 7 },
  ];

  patterns.forEach((pattern) => {
    const matches = replacedText.match(pattern.regex);
    matches &&
      matches.forEach((m) => {
        const cleanedMatch = m.replace(/[^\d]/gi, "");
        if (cleanedMatch.length === pattern.size) {
          replacedText = replacedText.replace(m, PHONE_MARKER);
        }
      });
  });

  return replacedText;
};

export default phoneMasking;
export const PHONE_MARKER_CONST = PHONE_MARKER;
